<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>

      <b-card no-body class="sales-settings">
        <div class="sales-settings__context">
          <AppIcon name="tune" />
          <span>Seleccioná una categoría para administrar la configuración de ventas.</span>
        </div>

        <b-tabs v-model="tabIndex"
                pills
                nav-class="sales-settings__tabs"
                content-class="sales-settings__content"
                active-nav-item-class="sales-settings__tab--active">
          <b-tab title="Mis Empresas" title-link-class="sales-settings__tab">
            <tab-business />
          </b-tab>

          <b-tab title="Puntos de Venta" title-link-class="sales-settings__tab">
            <tab-points-sales />
          </b-tab>

          <b-tab title="Condiciones de Pago" title-link-class="sales-settings__tab">
            <tab-methods-payment />
          </b-tab>

          <b-tab title="Condiciones de IVA" title-link-class="sales-settings__tab">
            <tab-iva-conditions />
          </b-tab>

          <b-tab title="Percepciones" title-link-class="sales-settings__tab">
            <tab-perceptions />
          </b-tab>

          <b-tab title="Conceptos" title-link-class="sales-settings__tab">
            <tab-concepts />
          </b-tab>

          <b-tab v-if="parameters.haveAcopio" title="Métodos de Acopio" title-link-class="sales-settings__tab">
            <tab-methods-acopio />
          </b-tab>

          <b-tab title="Configuraciones" title-link-class="sales-settings__tab">
            <tab-configurations />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
    import Profiles from '@/config/profiles'
    import Modules from '@/config/modules'
    import Helper from '@/handler/helper' 
    import Param from '@/config/parameters' 
    import TabPointsSales from './settings/crudPointsSales'
    import TabMethodsPayment from './settings/crudMethodsPayment'
    import TabIvaConditions from './settings/crudIvaConditions'
    import TabPerceptions from './settings/crudPerceptions'
    import TabConcepts from './settings/crudConcepts'
    import TabBusiness from '@/components/inc/myBusiness/business'
    import TabMethodsAcopio from './settings/crudMethodsAcopio'
    import TabConfigurations from './settings/crudConfigurations'
    import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

    export default {
        components: {
            TabPointsSales,
            TabMethodsPayment,
            TabIvaConditions,
            TabPerceptions,
            TabConcepts,
            TabBusiness,
            TabMethodsAcopio,
            TabConfigurations,
            TabHeaderActions,
        },
        data: () => {
            return {      
                access: {
                    module_id: Modules.VENTAS,
                    profile_id: Profiles.PERSONAL,
                    view_reference: 'settings',
                    elements: {}
                },
                parameters: {
                  haveAcopio: Helper.hasParametersAccess(Param.P49),                  
                },                       
                tabIndex: 0
            }
        },
        created () {     
            /* Configurar permisos de vistas y elementos */
            Helper.hasAccessView(this.access)
            /* Fin configuracion */
        },
    }
</script>

<style scoped>
.sales-settings {
  overflow: hidden;
  border-color: var(--app-color-border);
  background: var(--app-color-surface);
  box-shadow: var(--app-shadow-sm);
}

.sales-settings__context {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--app-color-border);
  background: var(--app-color-surface);
  color: var(--app-color-text-secondary);
  font-size: var(--app-text-sm);
}

.sales-settings__context .app-icon {
  color: var(--app-color-primary);
  font-size: 18px;
}

::v-deep .sales-settings__tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  margin: 0;
  padding: 12px 16px;
  overflow-x: auto;
  border-bottom: 1px solid var(--app-color-border);
  background: var(--app-color-surface);
  scrollbar-width: thin;
}

::v-deep .sales-settings__tabs .nav-item {
  flex: 0 0 auto;
}

::v-deep .sales-settings__tab.nav-link {
  padding: 7px 11px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: transparent;
  color: var(--app-color-text-secondary);
  font-size: var(--app-text-sm);
  font-weight: var(--app-font-medium);
  line-height: 1.25;
  white-space: nowrap;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}

::v-deep .sales-settings__tab.nav-link:hover {
  border-color: var(--app-color-primary-200);
  background: var(--app-color-primary-soft);
  color: var(--app-color-primary);
}

::v-deep .sales-settings__tab.nav-link:focus-visible {
  box-shadow: var(--app-focus-ring);
}

::v-deep .sales-settings__tab.nav-link.sales-settings__tab--active,
::v-deep .sales-settings__tab.nav-link.active {
  border-color: var(--app-color-primary-300);
  background: var(--app-color-primary-soft-hover);
  color: var(--app-color-primary-active);
}

::v-deep .sales-settings__content {
  margin-top: 0;
  padding: 0;
}

::v-deep .sales-settings__content > .tab-pane > .card-text {
  margin: 0;
  padding: 16px;
}

::v-deep .sales-settings__content > .tab-pane > div:not(.card-text) {
  padding: 16px;
}

::v-deep .sales-settings-configuration__groups > [class*="col-"] {
  padding-bottom: 4px;
}

::v-deep .sales-settings-configuration .form-group {
  margin-bottom: 16px;
}

::v-deep .sales-settings-configuration__footer {
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid var(--app-color-border);
}

@media (max-width: 767.98px) {
  .sales-settings__context {
    padding: 10px 12px;
  }

  ::v-deep .sales-settings__tabs {
    padding: 10px 12px;
  }

  ::v-deep .sales-settings__content {
    padding: 0;
  }

  ::v-deep .sales-settings__content > .tab-pane > .card-text {
    padding: 12px;
  }

  ::v-deep .sales-settings__content > .tab-pane > div:not(.card-text) {
    padding: 12px;
  }
}
</style>
